// extracted by mini-css-extract-plugin
export default {"draft-panel":"lsf-draft-panel","draft-panel__toggle":"lsf-draft-panel__toggle","waiting":"lsf-waiting"};